import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-request-property-app-form',
  templateUrl: './request-property-app-form.component.html',
  styleUrls: ['./request-property-app-form.component.css']
})
export class RequestPropertyAppFormComponent implements OnInit {

  // data: any;
  // ProjectList: any = [];
  // PL: any = {};
  // P: any = {};
  // Categorylist: any = [];
  // C: any = {};
  // Customerlist: any = [];
  // CU: any = {};
  // PropertyList: any = [];
  // Id: any;
  // Id2: number;
  // RequestForlist: any = [];
  // F: any = {};
  // ApplicantTypelist: any = [];
  // R: any = [];
  // formSubmitted: boolean;
  // REQP_ID: any;
  // mode: any;
  // title: string;
  // CUST_ID: number;
  // REQP_CA_ID: number;
  // id1: any;
  

  constructor() {
  }

  ngOnInit() {
    // this.GetProjectDetails();
    // this.GetCategoryDetails();
    // this.GetCustomerDetails();
    // this.GetApplicantType();
    // this.GetRequestFor();
    // this.route.params.subscribe(params => {
    //   debugger;
    //   this.REQP_ID = params['REQP_ID'];
    //   this.mode = params['mode'];

    //   if (this.REQP_ID > 0) {

    //     this.GetByIdRequestPropertyDetails(this.REQP_ID)
    //   }
    // });
    // if (this.mode == 'View') {
    //   this.title = "View Caste ";
    // }
    // else if (this.mode == 'Edit') {
    //   this.title = "Edit Caste ";
    // }
  }

  // GetProjectDetails() {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetProjectDetails();
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.ProjectList = response.Result;
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }
  // GetCategoryDetails() {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetCategoryDetails();
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.Categorylist = response.Result;
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }
  // GetCustomerDetails() {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetCustomerDetails();
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.Customerlist = response.Result;
  //       this.GetByIdCustomerDetails(this.R.CUST_ID);
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }
  // GetProperty(PD_Id, REQP_CA_ID) {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetProperty(PD_Id, REQP_CA_ID);
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.PropertyList = response;
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }

  // GetId(REQP_PD_ID) {
  //   this.Id = REQP_PD_ID;
  // }
  // GetIdCat(REQP_CA_ID) {
  //   this.Id2 = REQP_CA_ID;
  // }

  // GetRequestFor() {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetRequestFor();
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.RequestForlist = response.Result;
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }
  // GetApplicantType() {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetApplicantType();
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.ApplicantTypelist = response.Result;
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }

  // GetByIdCustomerDetails(CUST_ID) {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetByIdCustomerDetails(CUST_ID);
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.R = response;
  //       console.log(this.P);
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }
  // GetByIdRequestPropertyDetails(REQP_ID) {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetByIdRequestPropertyDetails(REQP_ID);
  //   this.data.subscribe(
  //     (response: any) => { 
  //       this.P = response;
  //       this.R = response;
  //       this.GetIdCat(this.P.REQP_CA_ID);
  //       this.PropertyList=response.PropertyList;
  //       console.log(this.P);
  //        this.GetRequestFor();
  //        this.GetProjectDetails();
  //        this.GetApplicantType();
  //        this.GetCustomerDetails();
  //         document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //          document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }
  // select(PR_Id) {
  //   this.Id = PR_Id;
  // }
}



// WEBPACK FOOTER //
// ./src/app/recovery/request-properties/request-property-approval/request-property-app-form/request-property-app-form.component.ts